@if (building(); as building) {
  <div id="map-nodes-view" class="grid grid-rows-12 grid-cols-12 gap-[10px] py-[10px] px-[20px]" cdkDropListGroup>
    <div class="row-span-12 col-span-4">
      <div class='h-full'>
        <app-unmapped-nodes-list
          [filterForm]="filterForm"
          [buildingId]="building.id"
          (onBlink)="issueBlinkCommand($event)"
          (onScroll)="onScroll($event)">
        </app-unmapped-nodes-list>
      </div>
    </div>
    <div class="row-span-12 col-span-8">
      <div class='h-full relative'>
        <app-floorplan
          [isActionsTrayEnabled]="false"
          (wheel)="onScroll($event.deltaY)"
          (onNodeDrop)="nodeDropped($event)"
          (onFloorplanRightClick)="handleFloorClick()"
          (onFloorplanDblClick)="handleFloorClick()"
          [buildingId]="building.id"
          (onNodeClick)="handleNodeClick($event)">
          @if (nodeClicked(); as context) {
            <ng-container>
              <div class="context-menu-container" [ngStyle]="{ 'top.px': context.y, 'left.px': context.x }">
                <div class="menu-content">
                  <div>
                    <button mat-mini-fab class="or-button or-warning" data-cy="unmap-button" (click)="unmapNode(context)">
                      <span class="or-icon or-small or-icon-node-unmap"></span>
                    </button>
                  </div>
                  @if(isConnected(context)) {
                    <div>
                      <button mat-mini-fab class='or-button or-primary'
                              data-cy='blink-button'
                              [disabled]='context.isPassiveNode'
                              (click)='blinkNode(context)'>
                        <span class='or-icon or-small or-icon-light-level'></span>
                      </button>
                    </div>
                  }
                </div>
              </div>
            </ng-container>
          }
        </app-floorplan>
        <button mat-fab
                color="primary"
                matTooltip="Refresh nodes on floorplan"
                matTooltipClass="mat-tooltip font-15"
                matTooltipPosition="above"
                aria-label="Button to refresh nodes in the floorplan"
                (click)="refreshNodesOnFloorplan()"
                class="refresh-floorplan-button"
                [class.refresh-floorplan-button--hidden]="isRefreshButtonHidden()"
                data-cy="btn-refresh-nodes-floorplan">
          <mat-icon>refresh</mat-icon>
        </button>
      </div>
    </div>
  </div>
} @else {
  <div class="absolute left-1/2 top-1/2">
    <mat-spinner></mat-spinner>
  </div>
}
